import React, { useContext, useEffect, useState } from "react";

import { Button, classnames, Icon, Thumbnail } from "@culturehq/components";

import { getImageFromStory, Trans } from "app/utils";
import imagesSizes from "constants/imagesSizes";

const StoryThumbnailSelect = ({
  story,
  index,
  onClick,
  selectStory,
  selectedStories,
  unselectStory
}) => {
  const [isSelectedStory, setIsSelectedStory] = useState(false);

  useEffect(() => {
    setIsSelectedStory(!!selectedStories.find(selectedStory => selectedStory.id === story.id));
  }, [selectedStories, story.id]);

  return (
    <div
      className={classnames("PhotoGroup__thumbnail", "Story")}
      onClick={() => onClick(index)}
      role="button"
      tabIndex={0}
    >
      <img
        className="story--image"
        src={story.media.mediaType === "video" ? story.media?.thumbnail : getImageFromStory(imagesSizes.NORMAL, story)}
        alt={story.imageAlt || story.question.question}
      />
      <div className="Story__information--profile">
        <div className="background-container">
          <div className="Story__creator">
            <Thumbnail image={story.creator.avatar.thumbUrl} />
            <div>
              <p>{story.creator.name}</p>
            </div>
          </div>
          {story.media.mediaType === "video" && (
            <Icon className="play-icon" icon="play-no-border" />
          )}
        </div>
        <div className="footer">
          {
            isSelectedStory
            && (
              <Button
                onClick={event => {
                  event.stopPropagation();
                  unselectStory(story);
                }}
                className="chq-btn-iv"
              >
                <Icon icon="checkmark" /><Trans>Selected</Trans>
              </Button>
            )
          }
        </div>
      </div>
      <div className="Story__information--profile Story__answer">
        <div className="background-container">
          <div className="footer">
            {
              isSelectedStory
                ? (
                  <Button
                    onClick={event => {
                      event.stopPropagation();
                      unselectStory(story);
                    }}
                    className="chq-btn-iv"
                  >
                    <Icon icon="checkmark" /><Trans>Selected</Trans>
                  </Button>
                )
                : (
                  <Button
                    onClick={event => {
                      event.stopPropagation();
                      selectStory(story);
                    }}
                  >
                    <Icon icon="ios-plus" />
                    <Trans>Select Story</Trans>
                  </Button>
                )
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoryThumbnailSelect;
